import React, { createContext, useContext, useState } from 'react';

const PoppupContext = createContext({ page: 0, size: 10, searchWrd: '', useYn: '' });

const PoppupProvider = ({ children }) => {
    const [options, setOptions] = useState({ page: 0, size: 10, searchWrd: '', useYn: '' });

    const value = {
        options,
        setOptions
    };

    return <PoppupContext.Provider value={value}>{children}</PoppupContext.Provider>;
};

const usePoppupContext = () => {
    return useContext(PoppupContext);
};

export { PoppupProvider, usePoppupContext };
